// extracted by mini-css-extract-plugin
export default {"row":"Row_row__5eMUb"};